import React from 'react';
import './Sub-services.css'; // Importa los estilos CSS para este componente

const OnGridContent = () => {
  return (
    <div className='containerSer'>
      <h2>Sistemas Fotovoltaicos ON GRID</h2>
      <p>
        Un sistema solar conectado a la red es una tecnología que convierte la energía solar en electricidad mediante paneles fotovoltaicos e inversores "on grid", los cuales están integrados a la red eléctrica nacional. Esta conexión permite un autoconsumo de la energía generada y venta de excedentes a la red eléctrica, generando ingresos que se reflejan en tu factura.
      </p>
      <p>
        Ofrecemos un servicio integral para la implementación de sistemas solares conectados a la red, que incluye: Cálculo de la capacidad, diseño del sistema según normativas vigentes; instalación de paneles solares, inversores y demás componentes, gestión completa de trámites legales y técnicos ante el Operador de Red y entidades certificadoras, cumpliendo con los requisitos establecidos en la Resolución CREG 174 y el RETIE, con el objetivo de brindarte una solución personalizada, segura, legal y rentable, adaptada a las condiciones técnicas y comerciales de tu propiedad.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Puedes reducir hasta en un 100% tu facturación de servicio de energía.</li>
        <li>Puedes convertir tu sistema en un ingreso pasivo por los excedentes que entregues a la red.</li>
        <li>Puedes deducir hasta el 50% de tu inversión del impuesto de renta (Ley 1715).</li>
        <li>Contribuyes directamente a la protección del medio ambiente y lucha contra el cambio climático.</li>
      </ul>
    </div>
  );
};

export default OnGridContent;
